import { LanguageModel } from './language.model';

export const Languages: LanguageModel[] = [
  {
    id: 1,
    name: 'فارسی',
    shortName: 'fa',
  },
  {
    id: 2,
    name: 'English',
    shortName: 'en',
  },
];
